import React from 'react';
// import Slide from '@material-ui/core/Slide';

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="down" ref={ref} {...props} />;
// });

export default function AlertDialogSlide({ modalShow, modalState }) {

  return (
    <div >
      <div>
        {/* <Button variant="outlined" onClick={handleClickOpen}></Button> */}
        {/* <Dialog disableBackdropClick={true}
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description">
            <DialogTitle className="dialog-modal-title" id="alert-dialog-slide-title">{"Delete file?"}</DialogTitle>
            <DialogContent className="dialog-modal-content" >
                <DialogContentText color="red[50]" classname="dialog-modal-contexts" id="alert-dialog-slide-description" >
                    You can't delete a file as long as it assigned to a playlist.
                </DialogContentText>
            </DialogContent>
            <DialogActions className="dialog-modal-action">
                <Button variant="contained" color="default" onClick={handleClose} >
                    Cancel
                </Button>
                <Button classname="button-color" className="color-changer" variant="contained" onClick={handleClose} >
                    OK
                </Button>
            </DialogActions>
        </Dialog> */}
      </div>
    </div>
  );
}
